export { default } from './Welcome'
export * from './Welcome.styles'
